var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-space',[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('a-tooltip',{attrs:{"title":_vm.description}},[_c('a-icon',{staticStyle:{"color":"rgba(0, 0, 0, 0.45)"},attrs:{"type":"question-circle"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }